import { TreeItemStatus } from '@core/enums/tree-item-status';
import { TreeItemType } from '@core/enums/tree-item-type';
import { DisplayItems, TaskDisplayItems } from '@core/interfaces/display-items';
import { InspectionRequest } from '@core/interfaces/inspection-request';
import { Task } from '@core/interfaces/items/task';
import { TreeItem } from '@core/interfaces/items/tree-item';
export const setFilesCount = (item: TreeItem, fileCount: number): void => {
  if (!item) {
    return;
  }
  switch (item.type) {
    case TreeItemType.Task: {
      (item as Task).fileCount = fileCount;
      break;
    }
  }
};

export const setStatus = (item: TreeItem, status: TreeItemStatus): void => {
  if (!item) {
    return;
  }
  item.status = status;
};

export const getItems = <T extends TreeItem | InspectionRequest, S extends DisplayItems<T>>(storeItems: S[], payload: S) => {
  let items = structuredClone(storeItems);
  if (!payload || (payload.pageCount === 0 && payload.data.length === 0)) {
    return items;
  }
  let existedOption;
  if ('projectId' in payload) {
    const taskDisplayItems = items as unknown as TaskDisplayItems[];
    existedOption = taskDisplayItems?.find(
      i =>
        i.sortOption.active === payload.sortOption.active &&
        i.sortOption.direction === payload.sortOption.direction &&
        i.sortOption.sortBy === payload.sortOption.sortBy &&
        i.textSearch === payload.textSearch &&
        i.status === payload.status &&
        i.includeArchived === payload.includeArchived &&
        i.projectId === (payload as unknown as TaskDisplayItems).projectId &&
        i.inspectionType === (payload as unknown as TaskDisplayItems).inspectionType,
    );
  } else {
    existedOption = items?.find(
      i =>
        i.sortOption.active === payload.sortOption.active &&
        i.sortOption.direction === payload.sortOption.direction &&
        i.sortOption.sortBy === payload.sortOption.sortBy &&
        i.textSearch === payload.textSearch &&
        i.status === payload.status &&
        i.includeArchived === payload.includeArchived,
    );
  }
  if (!items) {
    items = [payload];
  } else if (existedOption) {
    existedOption.data.push(...payload.data);
  } else {
    items = [...storeItems, payload];
  }
  return items;
};
